import { FormConfig } from 'common.types'
import { PA_COUNTIES, US_STATES, US_STATES__KEYS } from '../form.constants'
import { getDate18YearsAgo } from 'utilities/utilities'
import voterRegistrationStepValidate from '../voter-registration/helpers/voter-registration.step-validator'
import {
  VoterRegBelowFieldsContent,
  VoterRegFooterContent,
  VoterRegHeaderContent,
  VoterRegSuccessScreen,
} from '../voter-registration/components'
import voterRegistrationStateChangeHandler from '../voter-registration/helpers/voter-registration.state-change.handler'
import { VoterRegAboveFieldsContent } from '../voter-registration/components/VoterRegAboveFieldsContent'
import validateVoterRegEvent from '../voter-registration/helpers/voter-registration.event-validator'
export const voterRegistrationConfig: FormConfig = {
  captchaStep: 1,
  requireEitherEmailOrPhone: true,
  pollingOnSubmit: true,
  reviewSubmission: true,
  singlePage: true,
  requiredFieldGroups: ['reason', 'eligibility'],
  fields: [
    {
      name: 'firstName',
      type: 'text',
      maxLength: 30,
      required: true,
      step: 1,
    },
    {
      name: 'middleNameInitial',
      type: 'text',
      maxLength: 30,
      required: false,
      step: 1,
    },
    {
      name: 'lastName',
      type: 'text',
      maxLength: 30,
      required: true,
      step: 1,
    },
    {
      name: 'suffix',
      type: 'select',
      step: 1,
      selectOptions: ['I', 'II', 'III', 'IV', 'V', 'VI', 'VII', 'JR', 'SR'],
    },
    {
      name: 'birthDate',
      type: 'date',
      maxDefaultDate: new Date('11/04/2007'),
      minDate: new Date('01/01/1900'),
      required: true,
      validate: 'date',
      step: 1,
    },
    {
      name: 'county',
      type: 'select',
      selectOptions: PA_COUNTIES,
      selectLabelsFromOptions: true,
      required: true,
      step: 1,
    },

    {
      name: 'email',
      type: 'text',
      maxLength: 50,
      step: 1,
      validate: 'email',
    },
    {
      name: 'phone',
      type: 'phone',
      step: 1,
      validate: 'phone',
    },
    {
      name: 'optInSms',
      type: 'checkbox',
      step: 1,
    },
    {
      name: 'dataConsent',
      type: 'checkbox',
      required: true,
      step: 1,
    },
    {
      name: 'mustBePermanentAddress',
      type: 'accordion',
      accordionNoHeaderBottomMargin: true,
      step: 3,
    },
    {
      name: 'address',
      maxLength: 40,
      type: 'text',
      required: true,
      step: 3,
    },
    {
      name: 'addressTwo',
      maxLength: 40,
      type: 'text',
      step: 3,
    },
    {
      name: 'unitType',
      type: 'select',
      selectOptions: [
        'APT',
        'BLD',
        'BOX',
        'BSM',
        'CBN',
        'DEP',
        'FL',
        'FRN',
        'HNG',
        'HUB',
        'LBB',
        'LOT',
        'LOW',
        'OFC',
        'PH',
        'PIE',
        'POL',
        'REA',
        'RM',
        'SID',
        'SLI',
        'SMC',
        'SPC',
        'STE',
        'STO',
        'TH',
        'TRL',
        'TRLR',
        'UNI',
        'UPP',
      ],
      step: 3,
    },
    {
      name: 'unitNumber',
      type: 'text',
      maxLength: 15,
      step: 3,
    },
    {
      name: 'city',
      maxLength: 35,
      type: 'text',
      required: true,
      step: 3,
    },
    {
      name: 'zip',
      type: 'text',
      required: true,
      maxLength: 5,
      validate: 'zip',
      step: 3,
    },
    {
      name: 'hasAltMailingAddress',
      type: 'checkbox',
      step: 3,
    },
    {
      name: 'altAddress',
      maxLength: 40,
      type: 'text',
      required: true,
      step: 3,
      conditionalOn: 'hasAltMailingAddress',
    },
    {
      name: 'altCity',
      maxLength: 35,
      type: 'text',
      required: true,
      step: 3,
      conditionalOn: 'hasAltMailingAddress',
    },
    {
      name: 'altState',
      type: 'select',
      selectOptions: US_STATES__KEYS,
      required: true,
      step: 3,
      conditionalOn: 'hasAltMailingAddress',
      selectLabelsFromOptions: true,
    },
    {
      name: 'altZip',
      type: 'text',
      required: true,
      step: 3,
      conditionalOn: 'hasAltMailingAddress',
      validate: 'zip',
    },
    {
      name: 'eligibilityContent',
      type: 'html',
      step: 2,
      fieldGroup: 'eligibility',
    },
    {
      name: 'amUsCitizen',
      type: 'checkbox',
      fieldGroup: 'eligibility',
      required: true,
      step: 2,
    },
    {
      name: '18OrOlder',
      type: 'checkbox',
      fieldGroup: 'eligibility',
      required: true,
      step: 2,
    },
    {
      name: 'reasonNewRegistration',
      radioGroup: 'mainReason',
      type: 'radio',
      fieldGroup: 'reason',
      step: 2,
    },
    {
      name: 'reasonChangeRegistration',
      type: 'radio',
      radioGroup: 'mainReason',
      fieldGroup: 'reason',
      step: 2,
    },
    {
      name: 'reasonChangeOfName',
      conditionalOn: 'reasonChangeRegistration',
      type: 'checkbox',
      fieldGroup: 'reason',
      step: 2,
    },
    {
      name: 'previousFirstName',
      maxLength: 30,
      fieldGroup: 'reason',
      type: 'text',
      required: true,
      step: 2,
      conditionalOn: 'reasonChangeOfName',
    },
    {
      name: 'previousLastName',
      maxLength: 30,
      fieldGroup: 'reason',
      type: 'text',
      required: true,
      step: 2,
      conditionalOn: 'reasonChangeOfName',
    },
    {
      name: 'reasonChangeOfAddress',
      conditionalOn: 'reasonChangeRegistration',
      fieldGroup: 'reason',
      type: 'checkbox',
      step: 2,
    },
    {
      name: 'previousAddress',
      maxLength: 100,
      fieldGroup: 'reason',
      type: 'text',
      required: true,
      step: 2,
      conditionalOn: 'reasonChangeOfAddress',
    },
    {
      name: 'previousCity',
      maxLength: 30,
      fieldGroup: 'reason',
      type: 'text',
      required: true,
      step: 2,
      conditionalOn: 'reasonChangeOfAddress',
    },
    {
      name: 'previousState',
      fieldGroup: 'reason',
      type: 'select',
      selectOptions: US_STATES__KEYS.filter((state) => state === 'PA'),
      disabled: true,
      step: 2,
      conditionalOn: 'reasonChangeOfAddress',
      initialValue: 'PA',
    },
    {
      name: 'previousStateInfo',
      fieldGroup: 'reason',
      conditionalOn: 'reasonChangeOfAddress',
      type: 'html',
      step: 2,
    },
    {
      name: 'previousZip',
      fieldGroup: 'reason',
      type: 'text',
      maxLength: 5,
      validate: 'zip',
      required: true,
      step: 2,
      conditionalOn: 'reasonChangeOfAddress',
    },
    {
      name: 'previousCounty',
      fieldGroup: 'reason',
      type: 'select',
      selectOptions: PA_COUNTIES,
      selectLabelsFromOptions: true,
      required: true,
      step: 2,
      conditionalOn: 'reasonChangeOfAddress',
    },
    {
      name: 'previousYear',
      fieldGroup: 'reason',
      type: 'date',
      customErrorMessage: true,
      validate: 'date',
      dateOnlyYear: true,
      minDate: new Date('01/01/1900'),
      maxDefaultDate: new Date(),
      step: 2,
      conditionalOn: 'reasonChangeOfAddress',
    },
    {
      name: 'reasonChangeOfParty',
      conditionalOn: 'reasonChangeRegistration',
      fieldGroup: 'reason',
      type: 'checkbox',
      step: 2,
    },
    {
      name: 'reasonGovtEmployee',
      fieldGroup: 'reason',
      type: 'checkbox',
      step: 2,
    },
    {
      name: 'party',
      fieldGroup: 'party',
      type: 'select',
      selectOptions: ['D', 'R', 'GR', 'LN', 'NF', 'OTH'],
      step: 2,
      required: true,
    },
    {
      name: 'otherParty',
      fieldGroup: 'party',
      maxLength: 50,
      type: 'text',
      conditionalOn: 'party',
      conditionalOnSelectOption: 'OTH',
      required: true,
      step: 2,
    },
    {
      name: 'gender',
      fieldGroup: 'demographics',
      type: 'select',
      step: 4,
      selectOptions: ['F', 'M', 'U'],
    },
    {
      name: 'race',
      fieldGroup: 'demographics',
      type: 'select',
      step: 4,
      selectOptions: ['A', 'B', 'H', 'I', 'O', 'P', 'T', 'W'],
    },
    {
      name: 'interestPollWorker',
      fieldGroup: 'volunteer',
      type: 'checkbox',
      step: 4,
    },
    {
      name: 'interestInterpreter',
      fieldGroup: 'volunteer',
      type: 'checkbox',
      step: 4,
    },
    {
      name: 'languageSpoken',
      maxLength: 50,
      fieldGroup: 'volunteer',
      type: 'text',
      required: true,
      conditionalOn: 'interestInterpreter',
      step: 4,
    },
    {
      name: 'assistanceInfo',
      fieldGroup: 'assistance',
      type: 'html',
      step: 4,
    },
    {
      name: 'assistanceRequired',
      fieldGroup: 'assistance',
      type: 'checkbox',
      step: 4,
    },
    {
      name: 'assistanceType',
      fieldGroup: 'assistance',
      type: 'select',
      selectOptions: ['HI', 'VSI', 'WC', 'PD', 'IL', 'LN'],
      step: 4,
      required: true,
      conditionalOn: 'assistanceRequired',
    },
    {
      name: 'preferredLanguage',
      maxLength: 50,
      fieldGroup: 'assistance',
      type: 'text',
      conditionalOn: 'assistanceType',
      conditionalOnSelectOption: 'LN',
      required: true,
      step: 4,
    },

    {
      name: 'receivedHelp',
      fieldGroup: 'help',
      type: 'checkbox',
      step: 4,
    },
    {
      name: 'helpName',
      fieldGroup: 'help',
      maxLength: 100,
      type: 'text',
      required: true,
      conditionalOn: 'receivedHelp',
      step: 4,
    },
    {
      name: 'helpAddress',
      maxLength: 100,
      fieldGroup: 'help',
      type: 'text',
      required: true,
      conditionalOn: 'receivedHelp',
      step: 4,
    },
    {
      name: 'helpPhone',
      fieldGroup: 'help',
      type: 'phone',
      validate: 'phone',
      required: true,
      conditionalOn: 'receivedHelp',
      step: 4,
    },
    {
      name: 'helpTerms',
      fieldGroup: 'help',
      type: 'html',
      conditionalOn: 'receivedHelp',
      step: 4,
    },
    {
      name: 'helpAgreement',
      fieldGroup: 'help',
      required: true,
      type: 'checkbox',
      conditionalOn: 'receivedHelp',
      step: 4,
    },
    { name: 'idTopText', type: 'html', step: 5 },
    {
      name: 'idHelpText',
      type: 'html',
      step: 5,
    },
    {
      name: 'idCardNumber',
      type: 'text',
      step: 5,
      validate: 'pennDotId',
      conditionalOff: 'noPennDotId',
    },
    {
      name: 'noPennDotId',
      type: 'checkbox',
      conditionalOff: 'noId',
      step: 5,
    },
    {
      name: 'ssnLastFour',
      type: 'text',
      step: 5,
      validate: 'ssnLastFour',
      conditionalOff: 'noId',
      conditionalOn: 'noPennDotId',
    },
    {
      name: 'noId',
      conditionalOn: 'noPennDotId',
      type: 'checkbox',
      step: 5,
    },
    {
      type: 'html',
      name: 'ssnInfo',
      step: 5,
    },

    {
      type: 'html',
      name: 'signatureInfo',
      step: 5,
    },
    {
      name: 'signature',
      type: 'signature',
      validate: 'signature',
      customRequiredErrorMessage: true,
      required: true,
      step: 5,
    },
    {
      step: 6,
      name: 'iDeclareThat',
      type: 'html',
    },
    {
      name: 'terms',
      type: 'html',
      step: 6,
    },
    {
      name: 'agreement',
      type: 'checkbox',
      required: true,
      step: 6,
    },
    {
      name: 'mailinBallotInterest',
      type: 'checkbox',
      conditionalOn: 'idCardNumber',
      step: 7,
    },
    {
      name: 'mailinBallotAddressType',
      type: 'select',
      required: true,
      step: 7,
      selectOptions: ['R', 'M', 'A'],
      conditionalOn: 'mailinBallotInterest',
    },
    {
      name: 'mailinBallotAddress',
      maxLength: 40,
      type: 'text',
      required: true,
      step: 7,
      conditionalOn: 'mailinBallotInterest',
    },
    {
      name: 'mailinBallotCity',
      maxLength: 35,
      type: 'text',
      required: true,
      step: 7,
      conditionalOn: 'mailinBallotInterest',
    },
    {
      name: 'mailinBallotState',
      type: 'select',
      selectOptions: US_STATES__KEYS,
      required: true,
      step: 7,
      conditionalOn: 'mailinBallotInterest',
    },
    {
      name: 'mailinBallotZip',
      validate: 'zip',
      type: 'text',
      required: true,
      step: 7,
      conditionalOn: 'mailinBallotInterest',
    },
    {
      name: 'ward',
      maxLength: 50,
      type: 'text',
      step: 7,
      conditionalOn: 'mailinBallotInterest',
    },
    {
      name: 'livedSince',
      type: 'date',
      dateOnlyYear: true,
      customErrorMessage: true,
      minDate: new Date('01/01/1900'),
      maxDefaultDate: new Date(),
      validate: 'date',
      conditionalOn: 'mailinBallotInterest',
      required: true,
      step: 7,
    },
    {
      name: 'mailinBallotConfirmationTerms',
      type: 'html',
      step: 7,
      conditionalOn: 'mailinBallotInterest',
    },
    {
      name: 'mailinBallotConfirmation',
      type: 'checkbox',
      required: true,
      step: 7,
      conditionalOn: 'mailinBallotInterest',
    },
  ],
  validateStep: voterRegistrationStepValidate,
  stateChangeHandler: voterRegistrationStateChangeHandler,
  headerContent: VoterRegHeaderContent,
  footerContent: VoterRegFooterContent,
  validateEventResponse: validateVoterRegEvent,
  validateEventResponseType: 'submit',
  aboveFieldsContent: VoterRegAboveFieldsContent,
  belowFieldsContent: VoterRegBelowFieldsContent,
}
